<div class="relate-to-permit-card-main-container">
  <!-- header container -->
  <div class="header-container">
    <!-- Added by Amisha on 2026-09-22.
         Reason: provide the same mobile back navigation used by the parent inline expansion. -->
    <button
      type="button"
      class="relate-mobile-back"
      aria-label="Back to application details"
      (click)="closeCard()"
    >
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div class="left-content">
      <wm-common-text [data]="{text:'Add Related Permits to this Application'}"></wm-common-text>
    </div>
    <div class="right-content" [class.right-content-error]="relateToPermitDetails.fetchErrorRelatedApplications === true">
      @if(relateToPermitDetails.fetchErrorRelatedApplications === true){
         <wm-common-text [data]="{text:'Error fetching related permits'}"></wm-common-text>
      }@else {
        @if(relateToPermitDetails.fetchingRelatedApplications === true){
          <wm-common-text [data]="{text:'Fetching related permits...'}"></wm-common-text>
        }@else {
@if(relateToPermitDetails.relatedApplications.length > 0){
 <wm-common-text [data]="{text:'Related Permits:'}"></wm-common-text>
      @for (ra of relateToPermitDetails.relatedApplications; track $index) {
<wm-common-chip [data]="{
      label:ra.applicationNumber,
      removable:true
    }" (onDelete)="removeRelatedPermit(ra.workflowApplicationId)"></wm-common-chip>
      }
      }@else {
        <wm-common-text [data]="{text:'No Related Permits'}"></wm-common-text>
      }
        }
      }

    </div>
  </div>

   @if(relateToPermitDetails.fetchingRelatedApplications === false){
    <!-- table container -->
    <div class="table-container">
    <wm-common-table [isLoading]="relateToPermitDetails.loader" [errorMessage]="relateToPermitDetails.errorMsg" [loadingData]="relateToPermitDetails.dataLoader"
      [columns]="relateToPermitDetails.headers" [data]="relateToPermitDetails.rows" [tableType]="'Staff'"
      [serverSidePagination]="true" [totalPages]="relateToPermitDetails.totalNoOfPages" [currentPage]="relateToPermitDetails.pageNumber-1" [pageSize]="relateToPermitDetails.totalNoOfRows"
      (rowCheckboxClick)="onSpecificRowCheckboxClick($event)" (headerCheckboxClick)="onHeaderCheckboxClick($event)" (pageChange)="onPageChange($event)"
      [showRetryButton]="false" [showErrorIcon]="true"></wm-common-table>
  </div>
  <!-- action button container -->
  <div class="action-button-container">
    <!-- close button -->
    <div class="close-button">
      <wm-common-button [data]="{text:'CLOSE',onClick:closeCard.bind(this)}"></wm-common-button>
    </div>
    <!-- submit button -->
    <div class="submit-button">
      <ng-template #submitLoaderTemplate>
          <mat-progress-spinner mode="indeterminate" diameter="20">
          </mat-progress-spinner>
        </ng-template>
      <wm-common-button [data]="{text:relateToPermitDetails.submitting ? submitLoaderTemplate : 'SUBMIT',onClick:submitRelatedPermits.bind(this)}"></wm-common-button>

    </div>
  </div>
   }


</div>
<ng-template #applicationNoHeaderTemplate>
  <div class="header-cell-container">
    <wm-common-text [data]="{text:'Application #'}"></wm-common-text>
      <wm-common-textfield [data]="applicationNoSearchFieldConfig" [(ngModel)]="applicationNoSearchQuery"
      (ngModelChange)="handleApplicationNoSearchChange($event)">
    </wm-common-textfield>
  </div>
</ng-template>
<!-- <ng-template #permitNoHeaderTemplate>
  <div class="header-cell-container">
    <wm-common-text [data]="{text:'Permit #'}"></wm-common-text>
    <wm-common-textfield [data]="permitNoSearchFieldConfig" [(ngModel)]="permitNoSearchQuery"
      (ngModelChange)="handlePermitNoSearchChange($event)">
    </wm-common-textfield>
  </div>
</ng-template> -->
<ng-template #siteAddressHeaderTemplate>
  <div class="header-cell-container">
    <wm-common-text [data]="{text:'Site Address'}"></wm-common-text>
    <wm-common-textfield [data]="siteAddressSearchFieldConfig" [(ngModel)]="siteAddressSearchQuery"
      (ngModelChange)="handleSiteAddressSearchChange($event)">
    </wm-common-textfield>
  </div>
</ng-template>
<ng-template #workDescpHeaderTemplate>
  <div class="header-cell-container">
    <wm-common-text [data]="{text:'Description'}"></wm-common-text>
    <wm-common-textfield [data]="workDescriptionSearchFieldConfig" [(ngModel)]="workDescriptionSearchQuery"
      (ngModelChange)="handleWorkDescriptionSearchChange($event)">
    </wm-common-textfield>
  </div>
</ng-template>
<wm-common-confirmation-modal [data]="relateToPermitSubmitModalData" (onOkClick)="handleRelateToPermitModalOk()">
</wm-common-confirmation-modal>
<wm-common-confirmation-modal [data]="removeRelatedPermitConfirmationModalData" (onYesClick)="handleRemoveRelatedPermitModalAccepted()"
    (onNoClick)="handleRemoveRelatedPermitModalRejected()">
</wm-common-confirmation-modal>
